export default __webpack_public_path__ + "img/305cce95e404e18bb13737babbe4b973.svg";